<template>
    <div>
        <b-table
            id="table"
            :items="table"
            :fields="fields"
            :per-page="perPage"
            :current-page="currentPage"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            striped
            responsive="sm"
            hover>

            <template v-slot:cell(balance)="row">
                {{ row.item.balance | currency(symbol) }}
            </template>

            <template v-slot:cell(period_obj)="row">
                {{ row.item.period_obj | currency(symbol) }}
            </template>

            <template v-slot:cell(result)="row">
                {{ row.item.result | currency(symbol) }}
            </template>

            <template v-slot:cell(period_res_obj)="row">
                {{ row.item.period_res_obj | currency(symbol) }}
            </template>

            <template v-slot:cell(evolution)="row">
                {{ row.item.evolution | number('0.00') }} %
            </template>

            <template v-slot:cell(actions)="row">

                <a href="javascript:;" @click="showDiary(row.item.date)" v-b-tooltip.hover :title="__('objective.See Details of Day')">
                    <i class="fa fa-external-link-alt"></i>
                </a>

            </template>

        </b-table>

        <b-pagination
            v-model="currentPage"
            :total-rows="rows"
            :per-page="perPage"
            aria-controls="table"
        ></b-pagination>
    </div>
</template>

<script>
export default {
    props: ['table', 'currency', 'symbol', 'locale', 'actionActive'],
    data() {
        return {
            perPage: 10,
            currentPage: 1,
            sortBy: 'date',
            sortDesc: true,
            fields: [
                { key: 'date', label: this.__('objective.Date') },
                { key: 'balance', label: this.__('objective.Balance'), sortable: true },
                { key: 'period_obj', label: this.__('objective.Balance Desired'), sortable: true },
                { key: 'result', label: this.__('objective.Result'), sortable: true },
                { key: 'period_res_obj', label: this.__('objective.Desired Result'), sortable: true },
                { key: 'evolution', label: this.__('objective.Bankroll Evolution'), sortable: true },
            ],
        }
    },
    created() {
        if (this.actionActive) {
            this.fields.push({ key: 'actions', label: this.__('objective.Actions') })
        }
    },
    computed: {
        rows() {
            return this.table.length
        }
    },
    methods: {

        showDiary(date) {
            let dateFormat = this.$moment(date, 'DD/MM/YYYY').format('YYYY-MM-DD')
            window.location = '/' + this.locale + '/diary?date=' + dateFormat
        }
    }
}
</script>

<style scoped>

</style>
